// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_-mt","cls2":"shared-cls2_4me shared-cls1_-mt"};